export default [
  {
    name: 'housing',
    label: 'Housing',
    description: 'Will you need to upsize your home? Think about the cost of additional bedroom, moving, additional rent/mortgage interest cost, property taxes, maintenance, utilities.',
    enabled: true,
    value: 300,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'food',
    label: 'Food',
    description: 'Food and beverages purchased at grocery stores, dining out, school meals, etc.',
    enabled: true,
    value: 150,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'transportation',
    label: 'Transportation',
    description: 'Do you need to swap your hatchback for a minivan? Think about additional car lease/finance payment, gas, maintenance, etc.',
    enabled: false,
    value: 150,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'diapers',
    label: 'Diapers',
    description: 'Cost for diapers, re-usable or throw aways.',
    enabled: false,
    value: 40,
    startingAge: 0,
    endingAge: 3,
  },
  {
    name: 'clothing',
    label: 'Clothing',
    description: 'Including shirts, pants, footwear, jackets and other apparel.',
    enabled: false,
    value: 50,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'healthCare',
    label: 'Health care',
    description: 'Medical expenses that are not covered by health insurance, such as dental, orthodontia, vision, prescriptions, etc.',
    enabled: false,
    value: 25,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'fullTimeChildcare',
    label: 'Full-time childcare',
    description: 'Costs of daycare, nanny, baby sitting, etc. on a full-time basis (between 9-5).',
    enabled: false,
    value: 800,
    startingAge: 0,
    endingAge: 6,
  },
  {
    name: 'afterSchoolChildcare',
    label: 'After-school childcare',
    description: 'Costs of daycare, nanny, baby sitting, etc. after school hours.',
    enabled: false,
    value: 300,
    startingAge: 6,
    endingAge: 10,
  },
  {
    name: 'extraCurriculars',
    label: 'Extra-curriculars',
    description: 'Sports teams, after-school lessons, activities, camp, etc.',
    enabled: false,
    value: 100,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'educationSupplies',
    label: 'Education supplies',
    description: 'Pens, paper, books, software licenses, etc.',
    enabled: false,
    value: 50,
    startingAge: 4,
    endingAge: 18,
  },
  {
    name: 'holidaysAndCelebrations',
    label: 'Holidays and celebrations',
    description: 'Gifts during holidays, birthdays, and other celebrations such as graduations, etc.',
    enabled: false,
    value: 25,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'savingsForUniversityCollege',
    label: 'Savings for university / college',
    description: 'The amount of monthly savings put towards RESP - the default amount shown will maximize your free government grants.',
    enabled: false,
    value: 200,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'lifeInsurance',
    label: 'Your life insurance',
    description: 'If you have a child, you need life insurance.  Think about getting a new policy or increasing your existing coverage.',
    enabled: false,
    value: 150,
    startingAge: 0,
    endingAge: 18,
  },
  {
    name: 'lostIncome',
    label: 'Lost income',
    description: 'Lost income due to parent(s) staying at home to provide childcare, if applicable, enter your lost after-tax income.',
    enabled: false,
    value: 1000,
    startingAge: 0,
    endingAge: 2,
  },
]
